<template>
    <div class="dashContent">
        <banet-modal-confirm
                @confirmNo="confirm(false)"
                @confirmYes="confirm(true)"
                :show="showConfirm"
                :showFooter="true"
                :title="getTranslation('modal_confirm_title')"
                :body="getTranslation('label_confirm_contact_deleting')">
        </banet-modal-confirm>
        <banet-info
                :show="!display"
                :label="getTranslation('lbl_no_contacts')">
        </banet-info>

        <div class="panel-heading componentHeader">
            <div class="pull-left">
                <h2>{{ getTranslation('lbl_panel_headline_contacts') }}</h2>
            </div>
            <div class="pull-right">
                {{ getTranslation('lbl_tries') }}
                <span v-if="!triesEdit"><span class="badge">{{ client.tries ? client.tries : 1 }} </span>
                    <button @click.prevent="displayAttempts"
                            class="btn btn-default"
                            :title="getTranslation('lbl_edit')"
                    ><span
                            class="fa fa-pencil" aria-hidden="true"></span>
                    </button>
                </span>
                <span v-if="triesEdit">
                    <input min="1" type="number" class="form-control inp-tries" v-model="client.tries"
                           @key.enter="saveAttempts()" @key.esc="cancelAttempts">
                    <button @click.prevent="saveAttempts()"  class="btn btn-success"
                            :title="getTranslation('lbl_save')"><span
                            class="fa fa-floppy-o" aria-hidden="true"></span>
                    </button>
                    <button @click.prevent="cancelAttempts" class="btn"
                            :title="getTranslation('lbl_cancel')"><span
                            class="fa fa-ban" aria-hidden="true"></span></button>
                </span>
                <button class="btn btn-default"@click="displayAddContact()">
                    {{ getTranslation('btn_add_contact') }}</button>
                <router-link :to="`/history/contact/all/${client._id}`" tag="button"
                             class="btn btn-primary"
                             :title="getTranslation('lbl_history_deleted')">
                    <i class="fa fa-history" aria-hidden="true"></i>
                </router-link>
            </div>
        </div>
        <table class="table table-striped table-condensed table-bordered">
            <thead>
            <tr>
                <th>{{ getTranslation('lbl_contacts_table_position') }}</th>
                <th>{{ getTranslation('lbl_contacts_table_name') }}</th>
                <th>{{ getTranslation('lbl_contacts_table_phone') }}</th>
                <th class="action">{{ getTranslation('lbl_grid_col_action') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="showNewRow">
                <td></td>
                <td>
                    <input class="form-control" type="text" v-model="newContact.name">
                </td>
                <td>
                    <input class="form-control" type="text" @keyup="validatePhoneNum()" v-model="newPhone"
                           ref="newContactPhone">
                </td>
                <td style="white-space: nowrap;">
                    <button @click.prevent="addContact"  class="btn btn-success" ><span
                            class="fa fa-floppy-o" aria-hidden="true"
                            :title="getTranslation('lbl_save')"></span></button>
                    <button @click.prevent="cancelAddContact"  class="btn" ><span
                            class="fa fa-ban" aria-hidden="true"
                            :title="getTranslation('lbl_cancel')"></span></button>
                </td>
            </tr>
            <tr v-if="display" v-for="(contact, contactIndex) in contacts">
                <td><span v-if="!editable[contactIndex]">{{ contact.position }}</span></td>
                <td>
                    <span v-if="!editable[contactIndex]">{{ contact.name }}</span>
                    <input v-if="editable[contactIndex]"
                           @keyup.esc="refresh"
                           @keyup.enter="save(contact)"
                           class="form-control" type="text"
                           v-model="contact.name">
                </td>
                <td>
                    <span v-if="!editable[contactIndex]">{{ contact.phone }}</span>
                    <input v-if="editable[contactIndex]"
                           @keyup.esc="refresh"
                           @keyup.enter="save(contact)"
                           class="form-control" type="text"
                           v-model="contact.phone">
                </td>
                <td style="white-space: nowrap;">

                    <button  v-if="moveDisplay" @click.prevent="move(contact, -1)"
                             class="btn btn-default"
                             :title="getTranslation('lbl_move_up')"><span
                            class="fa fa-sort-asc" aria-hidden="true"></span></button>
                    <button  v-if="moveDisplay" @click.prevent="move(contact, 1)"
                             class="btn btn-default"
                             :title="getTranslation('lbl_move_down')"><span
                            class="fa fa-sort-desc" aria-hidden="true"></span></button>

                    <button  v-if="editable[contactIndex]" @click.prevent="save(contact)"  class="btn btn-success"
                             :title="getTranslation('lbl_save')"><span
                            class="fa fa-floppy-o" aria-hidden="true"></span></button>
                    <button  v-if="editable[contactIndex]" @click.prevent="remove(contact)"
                             class="btn btn-danger"
                             :title="getTranslation('lbl_delete')"
                            ><span
                            class="fa fa-trash-o" aria-hidden="true"></span></button>
                    <button  v-if="editable[contactIndex]" @click.prevent="cancelUpdateContact"
                             class="btn"
                             :title="getTranslation('lbl_cancel')"
                            ><span
                            class="fa fa-ban" aria-hidden="true"></span></button>
                    <button  v-if="!editable[contactIndex]"
                             @click.prevent="displayUpdateContact(contactIndex);"
                             class="btn btn-default"
                             :title="getTranslation('lbl_edit')"><span
                            class="fa fa-pencil" aria-hidden="true"></span></button>
                    <router-link :to="'/history/contact/' +  contact._id"
                                 tag="button"
                                 class="btn btn-primary"
                                 :title="getTranslation('lbl_history')">
                        <i class="fa fa-history" aria-hidden="true"></i></router-link>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { mainEventBus } from '../../../../main';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin.js';
    import {alertMixin} from '../../../../Banet/mixins/alertMixin.js';
    import {validationMixin} from '../../../../Banet/mixins/validationMixin';
    import { mixin as clickaway } from 'vue-clickaway';
    import BanetInfo from '../../../../Banet/errorsAndNotifications/BanetInfo.vue';
    import BanetModalConfirm from '../../../../Banet/errorsAndNotifications/BanetModalConfirm.vue';

    export default {
        props:['client'],
        mixins: [translationMixin, alertMixin, clickaway, validationMixin],
        components: {
            banetModalConfirm: BanetModalConfirm,
            banetInfo: BanetInfo
        },
        sockets: {
            clientContactData: function(data){
                if(this.client.tries < 1) { this.client.tries = 1; }
                this.contactList = data;
                this.oldValues.tries = this.client.tries;
//                this.setHistory();
            },
            loggedClientContactData: function(data){
                if(!data || data.length <= 0){
                    this.display = false;
                    mainEventBus.$emit( 'alert', { type:'info', msg:'lbl_no_contacts' } );
                } else {
                    this.display = true;
                    this.contactList = data;
                }
//               this.setHistory();
            },
            contactUpdated: function(){
                this.$socket.emit('getClientContact', this.client._id);
            }
        },
        data: function() {
           let newContact = {};
           newContact.phone = '';
            return {
               contactHistory: [],
                newContact: newContact,
                newPhone: '',
                triesEdit: false,
                editable: Array,
                showNewRow: false,
                contactList: [],
                init: false,
                selected: {},
                display: Boolean,
                clientId: '',
                oldValues: {
                    name: '',
                    phone: '',
                    tries: 0
                },
                moveDisplay: true
            }
        },
        created: function(){
            this.$socket.emit('getClientContact', this.client._id);
        },
        computed: {
            contacts: function(){
                if(this.client._id && this.init){
                    this.$socket.emit('getClientContact', this.client._id);
                    this.init = false;
                }
               if(this.contactList && this.contactList.length > 0) {
                  return this.contactList.filter(function (contact, index) {
                     return (index > 0);
                  });
               } else {
                  return this.contactList;
               }
            },
           displayHistory(){
               return this.contactHistory;
           }
        },
        methods: {
           setHistory(){
              let len = this.contactList.length;
              for(let i = 0; i < len; i++) {
                 if(this.contactList[i]._id) {
                    this.$http.get('history/count/' + this.contactList[i]._id).then(res => {
//                       this.contactHistory[this.contactList[i]._id] = res.data;
                       this.contactHistory[i] = res.data;
                    });
                 }
              }
           },
            displayAddContact: function(){
                this.refresh();
                this.moveDisplay = false;
                this.showNewRow = true;
            },
            cancelAddContact: function(){
                this.reset();
            },
            displayAttempts: function(){
                this.oldValues.tries = this.client.tries;
                this.refresh();
                this.triesEdit = true;
                this.moveDisplay = false;
            },
            cancelAttempts: function(){
                this.refresh();
            },
            saveAttempts: function(){
                if(this.client.tries < 1) { this.client.tries = 1; }
                this.$socket.emit('triesUpdate', this.client);
                this.oldValues.tries = this.client.tries;
                this.triesEdit = false;
                this.$http.post('refresh').then(res=>{
                    console.log('REFRESH');
                });
            },
            displayUpdateContact: function(contactIndex){
                this.refresh();
                this.editable[contactIndex] = true;
                this.moveDisplay = false;
            },
            cancelUpdateContact: function(){
                this.refresh();
            },
            save: function(contact){
               if(!this.validatePhone(contact.phone)){
                  return false;
               }
                this.$socket.emit('clientContactUpdate', contact);
                this.$http.post('refresh').then(res=>{
                    console.log('REFRESH');
                });
                this.refresh();
            },
            remove: function(contact){
                this.selected = contact;
                this.showConfirm = true;
            },
            confirm: function(y){
                this.showConfirm = false;
                if(y){
                    this.delete();
                } else {
                    this.refresh();
                    return false;
                }
            },
            delete: function(){
                this.$socket.emit('clientContactDelete', this.selected);
                this.$http.post('refresh').then(res=>{
                    console.log('REFRESH');
                });
                this.refresh();
            },
            addContact: function(){
                if(!this.newContact.name || !this.newContact.phone) {
                    mainEventBus.$emit('alert', {type: 'error', msg: 'warning_lbl_all_required'});
                    return false;
                }
                if(!this.validatePhone(this.newContact.phone)){
                   return false;
                }
                this.newContact.client = this.client._id;
                this.$socket.emit('clientContactCreate', this.newContact);
                this.newContact = {};
                this.showNewRow = false;
                this.moveDisplay = true;
                this.$http.post('refresh').then(res=>{
                    console.log('REFRESH');
                });
            },
            refresh: function(){
                this.reset();
                // reset changes
                this.init = true;
                this.client.tries = this.oldValues.tries;
            },
            reset: function(){
                this.triesEdit = false;
                this.showNewRow = false;
                this.editable = [];
                this.newContact = {};
                this.moveDisplay = true;
               this.newPhone = '';
            },
            move: function(contact, position){
                this.refresh();
                this.$socket.emit('contactMove', {contact: contact, move: position});
                this.$http.post('refresh').then(res=>{
                    console.log('REFRESH');
                });
            },
           validatePhoneNum(ind){
               if(ind){
//                  this.contacts[ind].phone = this.validatePhoneChar(this.contacts[ind].phone);

               } else {
                  this.newPhone = this.validatePhoneChar(this.newPhone);
                  this.newContact.phone = this.newPhone;
               }
           }
        }
    }
</script>

<style>
    .borderless th {
        border: none;
    }
    .inp-tries {
        display: inline-block;
        width: 50px;
    }
</style>


// WEBPACK FOOTER //
// Contacts.vue?351d847c